<template>
  <div class="image-cropper" ref="imageCropper" @mousedown.shift.capture="isShift = true" @mouseup.capture="isShift = false" @click.ctrl="centerBox()">
    <div v-show="!value">
      <input  type=file class="input-file" @click="(event) => {event.target.value = null}" :id="fileId" ref="file" accept=".jpg, .jpeg, .png" @change="openComputerImage()">
      <label class="input-label" :for="fileId">
        <slot></slot>
      </label>
      <button title="get image from Pinwall" @click.stop.prevent="showPinwall=!showPinwall" class="icon-button pinwall-btn">Pinwall</button>
      <pinwall v-if="showPinwall" @inputAsset="openPinwallImage" @close="showPinwall=false" :type="'image'"></pinwall>
    </div>
    <div v-show="value" class="image-display" @click="onImageClick()">
      <img :src="value" alt="preview"/>
      <div class="image-delete" @click.stop="deleteImage()">
        <i class="material-icons">delete_forever</i>
      </div>
      <div class="image-name" v-if="showImageName">
        {{imageName}}
      </div>
    </div>
    <div  id="cropper" ref="cropper" @dblclick="saveImage">
      <img v-show="false" ref="imageSrc" alt="source image"/>
      <img v-show="false" ref="imageDst" alt="destination image" crossorigin="anonymous"/>
      <button v-if="croppr" class="close-button" @click="close" title="Close image"><i class="material-icons">close</i></button>
      <button v-if="croppr" class="save-button" @click="saveImage" title="Save image"><i class="material-icons">save</i></button>
    </div>
  </div>
</template>

<script>
import Croppr from 'croppr'
import Pinwall from "../../pinwall"
import 'croppr/dist/croppr.min.css'

export default {
  name: 'ImageCropper',

  components: {
    Pinwall
  },

  props: {
    targetHeight: {
      type: Number
    },

    targetWidth: {
      type: Number
    },

    isModal: {
      type: Boolean,
      default: true
    },

    value: {
      type: String
    },

    showImageName: {
      default: false,
      type: Boolean
    }
  },

  data: function () {
    return {
      fileId: null,
      imageSrc: null,
      imageDst: null,
      imageName: "",
      showPinwall: false,
      croppr: null,
      box: null,
      isShift: false
    }
  },

  computed: {
    aspectRatio: function () {
      if (this.targetHeight && this.targetWidth) {
        return this.targetHeight / this.targetWidth
      } else {
        return null
      }
    }
  },

  created() {
    this.fileId = this.initComponentId();
    this.keyEventUnsubscribe = this.keyEventSubscribe(['image-cropper'], {
      'Enter': this.saveImage
    })
  },

  mounted() {
    if (this.isModal) {
      this.$refs.cropper.classList.add('modal-cropper')
    }
    if (this.value) {
      this.imageSrc = this.$refs.imageSrc
      this.imageSrc.src = this.value
    }
  },

  beforeDestroy() {
    this.keyEventUnsubscribe()
    if (this.croppr) {
      this.croppr.destroy()
      this.croppr = null
    }
  },

  methods: {
    initComponentId: function () {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    },

    initCropper: function () {
      this.croppr = new Croppr(this.$refs.imageSrc, {
        aspectRatio: this.aspectRatio,

        onCropMove: (value) => {
          if (this.box === null) {
            this.box = value
          }
          if ((this.box.height !== value.height) | (value.width - this.box.width) && (this.isShift)) {
            this.boxResizeAroundCenter(value)
          }
        },

        onCropEnd: (value) => {
          this.box = value
        }
      });

      this.box = this.croppr.getValue()
    },

    openComputerImage: function () {
      let file

      if (this.$refs.file.files && this.$refs.file.files[0]) {
        file = this.$refs.file.files[0]
        window.URL = window.URL || window.webkitURL

        this.openCropper(window.URL.createObjectURL(file))
      }
    },

    openPinwallImage: function (event) {
      this.showPinwall = false
      this.openCropper(event.url)
    },

    onImageClick: function (e) {
      if (this.value) {
        this.openCropper(this.value)
      }
    },

    openCropper: function (url) {
      this.imageSrc = this.$refs.imageSrc
      this.imageSrc.src = url

      this.imageSrc.onload = () => {
        this.initCropper()
        this.imageName = url.split("/").pop()
      }
    },

    saveImage: function (e) {
      e.preventDefault()

      if (this.croppr) {
        this.croppr.destroy()
        this.croppr = null
        this.renderImage()
      }
    },

    close: function(e) {
      e.preventDefault()
      if (this.croppr) {
        this.croppr.destroy()
        this.croppr = null
      }
    },

    renderImage: function () {
      let resultCanvas = document.createElement("canvas")
      let resultImageUrl

      let width = this.targetWidth || this.box.width
      let height = this.targetHeight || this.box.height

      if (this.targetWidth && !this.targetHeight) {
        height = (this.box.height / this.box.width) * width
      } else if (!this.targetWidth && this.targetHeight) {
        width = (this.box.width / this.box.height) * height
      }

      resultCanvas.width = width
      resultCanvas.height = height
      let resultCtx = resultCanvas.getContext("2d")

      this.imageDst = this.$refs.imageDst
      this.imageDst.src = this.imageSrc.src

      this.imageDst.onload = () => {
        if (this.imageDst) {
          resultCtx.drawImage(this.imageDst, this.box.x, this.box.y, this.box.width, this.box.height, 0, 0, width, height)
          resultImageUrl = resultCanvas.toDataURL()

          this.$emit('inputImage', resultImageUrl)
          this.imageDst = null
        } else {
          // eslint-disable-next-line
          console.log('nothing to render')
        }
      };
    },

    deleteImage: function () {
      this.$emit('deleteImage')
    },

    boxResizeAroundCenter: function (value) {
      let scaleFactor = 1
      let cropprImage = this.$refs.cropper.getElementsByClassName('croppr-image')[0]
      if (cropprImage) {
        scaleFactor = cropprImage.width / cropprImage.naturalWidth
      }

      let x1, x2, y1, y2
      let xCenter, yCenter

      xCenter = this.box.x + (this.box.width / 2)
      yCenter = this.box.y + (this.box.height / 2)

      x1 = xCenter - (value.width / 2)
      y1 = yCenter - (value.height / 2)
      x2 = xCenter + (value.width / 2)
      y2 = yCenter + (value.height / 2)

      let xmax = this.imageSrc.naturalWidth
      let ymax = this.imageSrc.naturalHeight

      if (x1 < 0) {
        x1 = 0
        x2 = value.width
      }
      if (y1 < 0) {
        y1 = 0
        y2 = value.height
      }
      if (x2 > xmax) {
        x2 = xmax
        x1 = xmax - (value.width)
      }
      if (y2 > ymax) {
        y2 = ymax
        y1 = ymax - (value.height)
      }

      this.croppr.box.x1 = x1 * scaleFactor
      this.croppr.box.x2 = x2 * scaleFactor
      this.croppr.box.y1 = y1 * scaleFactor
      this.croppr.box.y2 = y2 * scaleFactor

      this.croppr.redraw()
    }
  }
}
</script>
